import IFilter from '../../interfaces/AceleraMagenta/index/IFilter'
import { IAceleraMagentaAnswer } from '../../interfaces/IAceleraMagentaAnswer'
import { IAceleraMagentaStore } from '../../interfaces/IAceleraMagentaStore'
import apiService from '../Api'

export default class ConexaoMagentaService {
  async list(filter: IFilter) {
    return apiService.get('/conexao-magenta', { params: filter })
  }

  async getQuestions() {
    return apiService.get(`/conexao-magenta/get-questions`)
  }

  async getResponses(id: number, step: number) {
    return apiService.get(`/conexao-magenta/get-responses/${id}/${step}`)
  }

  async store(data: IAceleraMagentaStore) {
    return apiService.post('/conexao-magenta', data)
  }

  async update(id: number, data: IAceleraMagentaAnswer) {
    return apiService.put(`/conexao-magenta/${id}`, { answers: data })
  }

  async delete(id: number) {
    return apiService.delete(`/conexao-magenta/${id}`)
  }
}
